import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './store/authStore';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Alarms from './pages/Alarms';
import Anomaly from './pages/Anomaly';
import Historical from './pages/Historical';
import Admin from './pages/Admin';
import Hydrology from './pages/Hydrology';
import SuperAdmin from './pages/SuperAdmin';
import Planning from './pages/Planning';
import Invoice from './pages/Invoice';
import ShiftLog from './pages/ShiftLog';

interface ProtectedRouteProps {
  children:    React.ReactNode;
  permission?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, permission }) => {
  const { isAuthenticated, hasPermission } = useAuthStore();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (permission && !hasPermission(permission)) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="alarms"     element={<ProtectedRoute permission="alarms"><Alarms /></ProtectedRoute>} />
          <Route path="anomaly"    element={<ProtectedRoute permission="anomaly"><Anomaly /></ProtectedRoute>} />
          <Route path="historical" element={<ProtectedRoute permission="historical"><Historical /></ProtectedRoute>} />
          <Route path="hydrology"  element={<ProtectedRoute permission="hydrology"><Hydrology /></ProtectedRoute>} />
          <Route
            path="admin"
            element={
              <ProtectedRoute permission="admin">
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="planning"
            element={
              <ProtectedRoute permission="planning">
                <Planning />
              </ProtectedRoute>
            }
          />
          <Route
            path="invoice"
            element={
              <ProtectedRoute permission="invoice">
                <Invoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="shift-log"
            element={
              <ProtectedRoute permission="reports">
                <ShiftLog />
              </ProtectedRoute>
            }
          />
          <Route
            path="platform"
            element={
              <ProtectedRoute permission="super_admin">
                <SuperAdmin />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
